import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import DeviceDependentElement from 'components/DeviceDependentElement';
import Moment from 'moment';

class TimeField extends Component {
  static propTypes = {
    input: PropTypes.object.isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    error: PropTypes.string,
    className: PropTypes.string,
    componentProps: PropTypes.object,
  };

  state = {
    currentValue: '',
  }

  componentDidMount() {
    if (this.props.input.value) {
      this.presetValue(this.props.input.value);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.input.value) {
      this.presetValue(nextProps.input.value);
    }
  }

  componentWillUnmount() {
    if (this.props.error) {
      this.props.input.onChange('');
    }
  }

  presetValue = (val) => this.setState(() => {
    const time = Moment(val, 'HH:mm');
    return {
      currentValue: time.isValid() ? time.format('hh:mm A') : val,
    }
  });

  onChange = (e) => this.setState({ currentValue: e.target.value });
  tryParsingValue = () => {
    const formats = [
      'HH:mm',
      'hh:mm a',
      'hh:mm A'
    ];

    const time = Moment(this.state.currentValue, formats);

    if (time.isValid()) {
      this.setState({ currentValue: time.format('hh:mm A') });
      this.props.input.onBlur(time.format('HH:mm'));
    } else {
      this.props.input.onBlur(this.state.currentValue);
    }
  }

  render() {
    const { input, inputProps } = this.props;

    return (
      <div className="DynamicTimePicker">
        <DeviceDependentElement desktop>
          <Input
            {...input}
            onChange={this.onChange}
            onBlur={this.tryParsingValue}
            value={this.state.currentValue}
            className={this.props.className}
            placeholder={this.props.placeholder}
            {...inputProps}
          />
        </DeviceDependentElement>
        <DeviceDependentElement mobile>
          <input
            type="time"
            value={input.value}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
            className="form-control"
            {...inputProps}
          />
        </DeviceDependentElement>
      </div>
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <TimeField {...props} className={componentProps.className} />
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/TimeField.jsx